import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { pluralizeWord } from '../../service/Pluralize/Pluralize';

import './DealCellName.css';
import * as keyset from './DealCellName.i18n';

const i18n = i18nFactory(keyset);

export interface DealCellNameProps {
    id: string;
    name: string;
    numberOfLinkedCampaigns: number;
}

export class DealCellName extends React.Component<DealCellNameProps, {}> {
    render() {
        const { id, name, numberOfLinkedCampaigns } = this.props;

        const countObject = { count: numberOfLinkedCampaigns };

        return (
            <div className={Bem.cls('deal-cell-name')}>
                <div className={Bem.cls('deal-cell-name', 'value')}>{name}</div>
                <div className={Bem.cls('deal-cell-name', 'addition-info')}>
                    {id}
                    ,&nbsp;
                    {numberOfLinkedCampaigns
                        ? pluralizeWord(
                              [
                                  i18n('one-linked-camps', countObject),
                                  i18n('some-linked-camps', countObject),
                                  i18n('many-linked-camps-count', countObject)
                              ],
                              numberOfLinkedCampaigns
                          )
                        : i18n('zero-linked-camps')}
                </div>
            </div>
        );
    }
}
